<template>
  <div class="hello">
    <br />
    <table width="600" border="0" align="center" cellpadding="0" cellspacing="0" style="color:white;">
    <tr>
    <td height="460" align="center"><table width="600" border="0" align="center" cellpadding="0" cellspacing="0" :background="require('../assets/img/games/mc/bgw.jpg')">
    <tr>
    <td height="30"><span class="style3">Monster Crossing</span></td>
    </tr>
    <tr>
    <td height="198" align="center"><img src="../assets/img/games/mc/banner.jpg" width="592" height="198" /></td>
    </tr>
    <tr>
    <td height="322" valign="top"><table width="586" border="0" align="center" cellpadding="0" cellspacing="0">
    <tr>
    <td width="240">&nbsp;</td>
    <td width="346">&nbsp;</td>
    </tr>
    <tr>
    <td width="240"><p class="style26">Monster Crossing is a twist on the classic Frogger game. In this version, students are asked to read a word problem. Using the keyboard, the student navigates the monster across the busy four lane road and over the treacherous river to reach the correct answer.</p>
    <p class="style26">&nbsp;</p>
    <p class="style26">&nbsp;</p></td>
    <td width="346" valign="top"><br />
    <table width="320" border="0" align="center" cellpadding="0" cellspacing="0" background="whitespot.jpg">
    <tr>
    <td width="77" height="50" align="center"><router-link to="/games/monstercrossingadd"><img src="../assets/img/games/mc/icon_med.jpg" width="64" height="48" border="0" /></router-link></td>
    <td width="140"><span class="style27">Addition Word Problems</span></td>
    <td width="100"><router-link to="/games/monstercrossingadd"><img src="../assets/img/playsm.jpg" width="83" height="18" border="0" /></router-link></td>
    </tr>
    </table>
    <br />
    <table width="320" border="0" align="center" cellpadding="0" cellspacing="0" background="whitespot.jpg">
    <tr>
    <td width="78" height="50" align="center"><router-link to="/games/monstercrossingsub"><img src="../assets/img/games/mc/icon_med.jpg" width="64" height="48" border="0" /></router-link></td>
    <td width="140"><span class="style27">Subtraction Word Problems<span class="style29"></span></span></td>
    <td width="100" align="center"><router-link to="/games/monstercrossingsub"><img src="../assets/img/playsm.jpg" width="83" height="18" border="0" /></router-link></td>
    </tr>
    </table>
    <br />
    <table width="320" border="0" align="center" cellpadding="0" cellspacing="0" background="whitespot.jpg">
    <tr>
    <td width="78" height="50" align="center"><router-link to="/games/monstercrossingmul"><img src="../assets/img/games/mc/icon_med.jpg" width="64" height="48" border="0" /></router-link></td>
    <td width="140"><span class="style27">Multiplication Word Problems<span class="style29"></span></span></td>
    <td width="100" align="center"><router-link to="/games/monstercrossingmul"><img src="../assets/img/playsm.jpg" width="83" height="18" border="0" /></router-link></td>
    </tr>
    </table>
    <br />
    <table width="320" border="0" align="center" cellpadding="0" cellspacing="0" background="whitespot.jpg">
    <tr>
    <td width="78" height="50" align="center"><router-link to="/games/monstercrossingdiv"><img src="../assets/img/games/mc/icon_med.jpg" width="64" height="48" border="0" /></router-link></td>
    <td width="140"><span class="style27">Division Word Problems<span class="style29"></span></span></td>
    <td width="100" align="center"><router-link to="/games/monstercrossingdiv"><img src="../assets/img/playsm.jpg" width="83" height="18" border="0" /></router-link></td>
    </tr>
    </table></td>
    </tr>
    </table></td>
    </tr>
    </table></td>
    </tr>
    </table>


    <div @click="goBack()">Go Back</div>
  </div>
</template>

<script>
export default {
  name: 'MonsterCrossing',
  props: {
    msg: String
  },
  methods: {
    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/')
    },
    gameClick(game){
      console.log("launching "+game);
      this.$router.push(game);
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
